<script lang="ts">
  export let serviceUpgradeText: string;
</script>

{#if serviceUpgradeText}
  <section class="extra-service-upgrade-msg-section">
    <span class="c_icon_new c_icon_new--information"></span>
    <span class="info-text">{serviceUpgradeText}</span>
  </section>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .extra-service-upgrade-msg-section {
    margin: 16px 0;
    align-items: center;
    border: 1px solid $functional-yellow;
    border-radius: 8px;
    color: $functional-yellow;
    display: flex;
    font-size: 1.6rem;
    gap: 8px;
    padding: 12px;
    background: rgba(244, 202, 36, 0.08);
    .c_icon_new--information {
      font-size: 19px;
    }
    .info-text {
      color: $neutral-dark-02;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      @include desktop-min-width {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
</style>
